import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"

const Wrapper = styled(Link)`
  color: var(--primary);
  font-weight: 16px;
  text-decoration: none;
  background-color: var(--light);
  padding: 9px;
  border-radius: 3px;

  &:hover {
    background-color: var(--primary);
    color: #fff;

    p {
      color: #fff;
    }
  }

  span {
    font-size: 14px;
  }
  h4 {
    font-weight: bold;
    margin: 2px 0 8px;
  }
  p {
    font-size: 14px;
    margin: 0;
    color: var(--text-color);
  }
`
const ResearchResult = ({ to, type, onClick, title, excerpt }) => {
  return (
    <Wrapper {...{ to, onClick }}>
      <span>{type}</span>
      <h4>{title}</h4>
      <p>{excerpt}</p>
    </Wrapper>
  )
}

ResearchResult.propTypes = {
  to: PropTypes.string,
  image: PropTypes.string,
  type: PropTypes.string,
  title: PropTypes.string,
  onClick: PropTypes.func,
}

export { ResearchResult }
